import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';

import {
	OfferService
} from '../../services/index';
import { SelectItem } from '../../models/index';

import { LazyLoadEvent, Message, MenuItem } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: 'app-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss'],
  animations: []
})
export class EmailDialogComponent implements OnInit {
	//@Input('name') name: string;
	//@Input('email') email: string;

	@ViewChild('emailForm') public emailForm: NgForm;

	errors: Object = {};
	uiBlocked: boolean = false;
	form: any = {
		offer_id: 0,
		text: '',
		name: '',
		email: '',
		pdf: ''
	};

	dialogVisible: boolean = false;

	constructor(
		private router: Router,
		private translate: TranslateService,
		private offerService: OfferService,
		private messageService: MessageService
	) {}

	ngOnInit()
	{
		//this.form.name = this.name;
		//this.form.email = this.email;
	}

	public show(offer_id: number, name: string, email: string, template: string, pdf: string = '')
	{
		this.form.offer_id = offer_id;
		this.form.name = name;
		this.form.email = email;
		this.form.text = template;
		this.form.pdf = pdf;

		this.dialogVisible = true;
	}

	public hide()
	{
		this.dialogVisible = false;
	}

	public onSubmit()
	{
		this.uiBlocked = true;

		this.offerService.sendEmail(this.form).subscribe(response => {
			if(response.success) {
				this.messageService.add({severity:'success', summary:'Email', detail:'Email is verstuurd!'});
			} else {
				this.messageService.add({severity:'error', summary:'Email', detail:'Email kon niet verstuurd worden!'});
			}

			this.hide();

			this.uiBlocked = false;
		});
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/email-dialog/email-dialog.component.ts